import { render, staticRenderFns } from "./formblank.vue?vue&type=template&id=6e78d8c1"
import script from "./formblank.vue?vue&type=script&lang=js"
export * from "./formblank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports